import { useContext } from 'react';
import { type AppContextType } from 'src/types';

import { AppContext } from '../AppContextProvider';

const useAppContext = (): AppContextType => {
  return useContext(AppContext);
};

export default useAppContext;
